module.exports = __webpack_public_path__ + "static/media/fm_icon_warning.70a03d6d.png";